import React, { useState, useEffect } from "react";
import {
    // useLocation, 
    useNavigate,
    useSearchParams
} from "react-router-dom";
import {
    Drawer,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    IconButton,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    // DialogActions,
    // TextField,
    Tooltip,
    Button,
    Alert,
    Snackbar,
    Card,
    CardContent,
    Collapse
} from "@mui/material";
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Chip } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
    Add,
    ArrowBackIosNew,
    ArrowForwardIos,
    ArrowDropDown,
    ArrowRight,
} from "@mui/icons-material";
import { grey } from "@mui/material/colors";

import { createList } from "../services/userService";
import { createCheckoutSession, redirectToCheckout, getPaymentStatus } from "../services/paymentService";

import getlistaLight from "../assets/images/logoDark.svg";
import getlistssmall from "../assets/images/logoDark.png";

const drawerWidth = 80;
const expandedWidth = 200;

// const bottomLinks = [
//   // { label: "Help", icon: <HelpCenterOutlinedIcon />, href: "/help" },
//   // { label: "Integrations", icon: <IntegrationInstructionsOutlinedIcon />, href: "/integrations" },
//   { label: "Logout", icon: <ExitToAppOutlinedIcon />, href: "/logout", onClick: handleLogout },
// ];

export default function DashboardDrawer({ open, onToggle }) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [listsOpen, setListsOpen] = useState(false);
    // const [creditsOpen, setCreditsOpen] = useState(false);
    const [creditsDialogOpen, setCreditsDialogOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [listData, setListData] = useState({
        name: '',
        description: ''
    });
    const [alert, setAlert] = useState(null);
    const [paymentNotification, setPaymentNotification] = useState(null);

    let user = null;
    try {
        const userInfo = typeof window !== 'undefined' ? localStorage.getItem('userInfo') : null;
        user = userInfo ? JSON.parse(userInfo) : null;
    } catch {
        user = null;
    }

    const topLinks = [
        { label: "Auto Pilot", icon: <AutoAwesomeIcon />, href: "/workflow" },
        { label: "Lists", icon: <ListOutlinedIcon />, href: "/lists" },
        ...(user && !user.parentId ? [{ label: "Team", icon: <GroupsOutlinedIcon />, href: "/teams" }] : []),
        { label: "Searches", icon: <ManageSearchOutlinedIcon />, href: "/searches" },
        ...(['arnab@getlista.io', 'gaurav@getlista.io', 'arnabmakur@gmail.com'].includes((user?.email || '').trim().toLowerCase())
            ? [{ label: "ICP search", icon: <PersonSearchOutlinedIcon />, href: "/icp-search" }]
            : []),
    ];

    // Check for payment status in URL params
    useEffect(() => {
        const paymentStatus = searchParams.get('payment');
        const sessionId = searchParams.get('session_id');
        const credits = searchParams.get('credits');
        const amount = searchParams.get('amount');

        if (paymentStatus && sessionId) {
      
            if (paymentStatus === 'success') {
                setPaymentNotification({
                    type: 'success',
                    message: `Payment successful! ${credits} credits added for $${amount}`,
                    sessionId
                });
                // Fetch detailed payment status
                fetchPaymentDetails(sessionId);
            } else if (paymentStatus === 'canceled') {
                setPaymentNotification({
                    type: 'warning',
                    message: 'Payment was canceled',
                    sessionId
                });
            }
        }
    }, [searchParams]);

    const fetchPaymentDetails = async (sessionId) => {
        try {
            const response = await getPaymentStatus(sessionId);
            setPaymentNotification(prev => ({
                ...prev,
                details: response.data
            }));
        } catch (error) {
            console.error('❌ Error fetching payment details:', error);
        }
    };

    // Credit packages
    const creditPackages = [
        { id: 1, credits: 44, price: 50, popular: false },
        { id: 2, credits: 66, price: 75, popular: true },
        { id: 3, credits: 90, price: 100, popular: false }
    ];

    // Helper function to format date
    const formatDateOnly = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            return dateString; // Return original string if parsing fails
        }
    };

    // User data is now parsed at the top level for conditional menu rendering
    // console.log('👤 Parsed user data:', JSON.stringify(user, null, 2));
// 
    const handleListsClick = () => setListsOpen((prev) => !prev);
    const handleCreditsClick = () => setCreditsDialogOpen(true);
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAddClick = () => {
        // setDialogOpen(true);
    };

    const handleDialogClose = () => {
        // setDialogOpen(false);
        setListData({ name: '', description: '' });
    };

    const handleCreditsDialogClose = () => {
        setCreditsDialogOpen(false);
    };

    const handleBuyCredits = async (packageId) => {
    
        try {
            const selectedPackage = creditPackages.find(pkg => pkg.id === packageId);
            if (!selectedPackage) {
                console.error('❌ Invalid package selected');
                setAlert({ message: 'Invalid package selected', severity: 'error' });
                return;
            }

            // Create checkout session
            const response = await createCheckoutSession(selectedPackage);
            if (response.status === 'success') {
                // Redirect to Stripe checkout
                redirectToCheckout(response.data.url);
                setCreditsDialogOpen(false);
            } else {
                console.error('❌ Failed to create checkout session:', response.message);
                setAlert({ message: response.message || 'Failed to create checkout session', severity: 'error' });
            }
        } catch (error) {
            console.error('❌ Error in handleBuyCredits:', error);
            console.error('Error details:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status
            });
            setAlert({ 
                message: error.response?.data?.message || 'An error occurred while processing payment', 
                severity: 'error' 
            });
        }
    };

    const handleContactUs = () => {
        if (typeof window !== 'undefined' && window.Tawk_API) {
            window.Tawk_API.maximize();
        }
        setCreditsDialogOpen(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setListData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        try {
            const response = await createList(listData);
            if (response.status === 'success') {
                setAlert({ message: `"${listData.name}" created successfully!`, severity: 'success' });
                handleDialogClose();
            } else {
                setAlert({ message: response.message || 'Failed to create list. Please try again.', severity: 'error' });
            }
        } catch (error) {
            console.error('Error creating list:', error);
            setAlert({ message: error.response?.data?.message || 'An error occurred. Please try again.', severity: 'error' });
        }
    };

    const handleLogout = () => {
        handleClose();
        localStorage.removeItem('userInfo');
        navigate('/');
    };

    return (
        <Drawer 
            variant="permanent" 
            open={open} 
            slotProps={{ 
                paper: { 
                    sx: { 
                        width: open ? expandedWidth : drawerWidth, 
                        transition: "width 0.5s", 
                        overflowX: "hidden", 
                        bgcolor: grey[100], 
                        zIndex: 1101,
                        // display: { xs: 'none', md: 'block' } // Hide on xs and sm screens
                    }, 
                }, 
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", alignContent: "center", justifyContent: "center", padding: 1, position: 'relative'}} >
                
                {/* Logo */}
                <Box display="flex" padding={1} alignItems="center" justifyContent="center" component="a" href="/dashboard" >
                    {open ? (
                        <img src={getlistaLight} alt="GetLista" style={{ display: "block", maxHeight: 35 }} />
                    ) : (
                        <img src={getlistssmall} alt="GetLista" style={{ display: "block", maxHeight: 35 }} />
                    )}
                </Box>
                {/* Logo */}
                
                {/* Toggle Button */}
                {open && (
                    <IconButton
                        size="small"
                        onClick={onToggle}
                        sx={{
                            position: 'fixed',
                            left: open ? expandedWidth - 15 : drawerWidth - 15,
                            bgcolor: grey[500],
                            width: 25,
                            height: 25,
                            '&:hover': { bgcolor: grey[500] },
                            transition: 'right 0.5s'
                        }}
                    >
                        <ArrowBackIosNew fontSize="inherit" sx={{ color: "white" }} />
                    </IconButton>
                )}
                {!open && (
                    <IconButton
                        size="small"
                        onClick={onToggle}
                        sx={{
                            position: 'fixed',
                            left: drawerWidth - 15,
                            bgcolor: grey[500],
                            width: 25,
                            height: 25,
                            '&:hover': { bgcolor: grey[500] },
                            transition: 'left 0.5s'
                        }}
                    >
                        <ArrowForwardIos fontSize="inherit" sx={{ color: "white" }} />
                    </IconButton>
                )}
            </Box>
            {/* Divider */}
            <Divider />
            {/* Divider */}
            
            {/* Main content container with flex layout */}
            <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 120px)' }}>
                {/* Menu */}
                <List alignitems="center" sx={{ padding: 2 }}>
                    {/* Top Links */}
                    {topLinks.map((item) => (
                        <ListItem button="true" key={item.label} component="a" href={item.href} sx={{ py: 1.5, justifyContent: "center" }}>  
                            <ListItemIcon sx={{ minWidth: 0, color: "#424242", justifyContent: "center" }}>{item.icon}</ListItemIcon>
                            {open && (
                                <ListItemText primary={item.label} sx={{ color: "#424242", pl: 2 }} />
                            )}
                        </ListItem>
                    ))}
                    {/* Top Links */}
                    <Divider sx={{ my: 1 }} />
                    {/* Credits Dropdown */}
                    <ListItem button="true" component="a" href="#" onClick={handleCreditsClick} sx={{ py: 1.5, justifyContent: "center" }}>
                        <ListItemIcon sx={{ minWidth: 0, color: "#424242", justifyContent: "center" }}>
                            <AddCardOutlinedIcon />
                        </ListItemIcon>
                        {open && <ListItemText primary="Credits" sx={{ color: "#424242", pl: 2 }} />}
                    </ListItem>
                </List>

                {/* Spacer to push subscription box to bottom */}
                <Box flexGrow={1} />

                {/* Subscription Expiry Info - Always at bottom */}
                <Box sx={{ py: 1, m: 1,}}>
                    <Divider sx={{ my: 1 }} />
                    <List>
                        <ListItem button="true" component="a" href="#" onClick={handleLogout} key="Logout" sx={{ py: 1.5, justifyContent: "center" }}>
                            <ListItemIcon sx={{ minWidth: 0, color: "#424242", justifyContent: "center" }}>
                                <ExitToAppOutlinedIcon />
                            </ListItemIcon>
                            {open && (
                                <ListItemText primary="Logout" sx={{ color: "#424242", pl: 2 }} />
                            )}
                        </ListItem>
                    </List>
                    <Divider />
                    {/* <Typography variant="caption">Valid till: {formatDateOnly(user.planExpiry)}</Typography>
                     */}
                     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 1.5 }}>
                    <Tooltip title={user?.planExpiry ? `Subscription Expires on ${formatDateOnly(user.planExpiry)}` : 'No subscription information'} arrow>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                        ⏳ Exp: { user?.planExpiry ? formatDateOnly(user.planExpiry) : 'Expired'}
                        </Typography>
                    </Tooltip>
                    </Box>
                </Box>
            </Box>
      

        {/* Add List Dialog */}
        {/* <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
            <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Create New List</Typography></DialogTitle>
            {alert && <Alert onClose={() => setAlert(null)} severity={alert?.severity}>{alert?.message}</Alert>}
            
            <DialogContent>
                <Box sx={{ pt: 1 }}>
                    <TextField autoFocus margin="dense" name="name" label="List Name" type="text" fullWidth variant="outlined" value={listData.name} onChange={handleInputChange} sx={{ mb: 2 }} />
                    <TextField margin="dense" name="description" label="Description (Optional)" type="text" fullWidth variant="outlined" multiline rows={3} value={listData.description} onChange={handleInputChange} />
                </Box>
            </DialogContent>
        
            <DialogActions sx={{ p: 3, pt: 1 }}>
                <Button onClick={handleDialogClose} sx={{ color: '#666' }}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={!listData.name.trim()}sx={{ bgcolor: '#1ce484','&:hover': { bgcolor: '#20ec84' },'&:disabled': { bgcolor: '#ccc' }}}>Create List</Button>
            </DialogActions>

        </Dialog> */}
        {/* Add List Dialog */}

        {/* Credits Dialog */}
        <Dialog open={creditsDialogOpen} onClose={handleCreditsDialogClose} maxWidth="md" fullWidth>
            
            <DialogTitle>
                <Typography variant="h5" sx={{ fontWeight: 600, textAlign: 'center' }}>Buy Credits</Typography>
                <Typography variant="body2" sx={{ color: '#666', textAlign: 'center', mt: 1 }}>
                    Choose a credit package that suits your needs
                </Typography>
            </DialogTitle>
            
            <DialogContent>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center', mt: 2 }}>
                    {creditPackages.map((creditPackage) => (
                        <Card
                            key={creditPackage.id}
                            sx={{
                                minWidth: 200,
                                border: creditPackage.popular ? '2px solid #1ce484' : '1px solid #e0e0e0',
                                borderRadius: 2,
                                position: 'relative',
                                '&:hover': {
                                    boxShadow: 4,
                                    transform: 'translateY(-2px)',
                                    transition: 'all 0.2s ease-in-out'
                                }
                            }}
                        >
                            {creditPackage.popular && (
                                <Box sx={{
                                    position: 'absolute',
                                    top: -10,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    bgcolor: '#1ce484',
                                    color: '#000',
                                    px: 1,
                                    py: 1,
                                    borderRadius: 1,
                                    fontSize: '0.75rem',
                                    fontWeight: 600
                                }}>Most Popular</Box>
                            )}
                        
                            <CardContent sx={{ textAlign: 'center', pt: creditPackage.popular ? 3 : 2 }}>

                                <Typography variant="h4" sx={{ fontWeight: 700, color: '#1ce484', mb: 1 }}>{creditPackage.credits}</Typography>
                                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Credits</Typography>
                                <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>${creditPackage.price}</Typography>
                                <Button variant="contained" fullWidth onClick={() => handleBuyCredits(creditPackage.id)} sx={{ bgcolor: '#1ce484', color: '#000', fontWeight: 600, '&:hover': { bgcolor: '#20ec84' }}}>
                                    Buy Now
                                </Button>
                            
                            </CardContent>
                        </Card>
                    ))}
                    
                    {/* Contact Us Card */}
                    <Card
                        sx={{
                            minWidth: 200,
                            border: '2px solid #3b82f6',
                            borderRadius: 2,
                            position: 'relative',
                            '&:hover': {
                                boxShadow: 4,
                                transform: 'translateY(-2px)',
                                transition: 'all 0.2s ease-in-out'
                            }
                        }}
                    >
                        <CardContent sx={{ textAlign: 'center', pt: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#3b82f6', mb: 1 }}>Customize</Typography>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Credits</Typography>
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>Contact Us</Typography>
                            <Button 
                                variant="contained" 
                                fullWidth 
                                onClick={handleContactUs} 
                                sx={{ 
                                    bgcolor: '#3b82f6', 
                                    color: '#fff', 
                                    fontWeight: 600, 
                                    '&:hover': { bgcolor: '#2563eb' }
                                }}
                            >
                                Contact Us
                            </Button>
                        </CardContent>
                    </Card>
                </Box>
            </DialogContent>
        
            {/* <DialogActions sx={{ p: 3, pt: 1 }}>
                <Button onClick={handleCreditsDialogClose} sx={{ color: '#666' }}>Cancel</Button>
            </DialogActions> */}
        </Dialog>
        {/* Credits Dialog */}

        {/* Alert Snackbar */}
        <Snackbar open={alert !== null} autoHideDuration={6000} onClose={() => setAlert(null)}>
            <Alert onClose={() => setAlert(null)} severity={alert?.severity}>{alert?.message}</Alert>
        </Snackbar>

        {/* Payment Notification Snackbar */}
        <Snackbar open={paymentNotification !== null} autoHideDuration={8000} onClose={() => setPaymentNotification(null)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Alert onClose={() => setPaymentNotification(null)} severity={paymentNotification?.type} sx={{ minWidth: 300 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>{paymentNotification?.message}</Typography>
                {paymentNotification?.details && (
                    <Box sx={{ mt: 1, fontSize: '0.8rem' }}>
                        <Typography variant="caption" display="block">Status: {paymentNotification.details.status}</Typography>
                        <Typography variant="caption" display="block">Payment: {paymentNotification.details.paymentStatus} </Typography>
                    </Box>
                )}
            </Alert>
        </Snackbar>
        {/* Payment Notification Snackbar */}

    </Drawer>
  );
}